import React, { useEffect, useState } from "react";
import { Alert, Box, Card } from '@curves/ui-base';

import ChangeRecordCardMain from "./ChangeRecordCardMain";
import ChangeRecordCardAttachment from "./ChangeRecordCardAttachment";
import TimelineRecordItem from "./TimelineRecordItem";
import { isEmpty } from "@Util/utils";
import { adaptCycleOrderChange } from "./types/adaptCycleOrderChange";
import { parseDate } from "@Util/moment.util";
import useCyclePurchaseOverviewApi from "@Apis/useCyclePurchaseOverviewApi";
const ChangeRecordCard = ({ onPreviewPdf, extraSection, memberID, cycleOrderID }) => {
	const { getCyclePurchaseDetailHistoryApi } = useCyclePurchaseOverviewApi();
	const [historyData, setHistoryData] = useState([]);
	// 獲取歷史記錄資料
	useEffect(
		() => {
			let isMounted = true;
			const fetchHistoryData = async () => {
				if (!memberID || !cycleOrderID) return;
				try {
					const response = await getCyclePurchaseDetailHistoryApi({
						memberID: memberID,
						cycleOrderID: cycleOrderID,
					});
					// 只有在組件仍然掛載時才更新狀態
					if (isMounted) {
						setHistoryData(response);
					}
				} catch (error) {
					console.error("Failed to fetch history data:", error);
				}
			};
			fetchHistoryData();
			// 清理函數
			return () => {
				isMounted = false;
			};
		},
		// eslint-disable-next-line
		[memberID, cycleOrderID, getCyclePurchaseDetailHistoryApi]
	);
	const historyDataSchema = historyData.map(item => {
		const adaptedData = adaptCycleOrderChange(item);
		return {
			metainfo: [
				{ label: "申請日期", text: parseDate(item.createDate) },
				{ label: "生效日期", text: parseDate(item.effectDate) || "無相關資料" },
				{ label: "擔當", text: item.employeeName || "未知" },
			],
			id: item.effectID || item.cycleOrderID,
			title: adaptedData.title,
			pdfUrl: item.url,
			type: adaptedData.type,
			descList: adaptedData.descList,
		};
	});
	if (isEmpty(historyData)) {
		return (
			<Alert severity="info" color="info" variant="standard">
				尚無資料
			</Alert>
		);
	}
	return (
		<Box className="change-record-timeline">
			{historyDataSchema.map(record => (
				<TimelineRecordItem key={record.id} metainfo={record.metainfo}>
					<Card className={`change-record-card status-${record.type} p-3`}>
						{record.pdfUrl && <ChangeRecordCardAttachment pdfUrl={record.pdfUrl} onClick={() => onPreviewPdf?.(record.pdfUrl)} />}
						<Box className="change-record-card__content" style={{ display: "flex", alignItems: "center" }}>
							<ChangeRecordCardMain title={record.title} descList={record.descList} extraSection={extraSection} />
						</Box>
					</Card>
				</TimelineRecordItem>
			))}
		</Box>
	);
};
export default ChangeRecordCard;
